import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSOctorateStore = GenericCollectionFactory("PMS-OCTORATE-INTEGRATION", "id");